export default {
  functionKey: "MOD",
  title: "MOD",
  group: "Calcul",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Divisor", name: "Diviseur" }],
  expectedArguments: [
    { name: "Diviseur", argumentKey: "Divisor", single: true, initialValue: "2" }
  ],
  description: "Retourne le reste de la division. (Ex: MOD(10, 3) -> 1)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const divisor = args[0] ?? "1";
    const jsCode = `${destination} = ${origin} % ${divisor};`;
    const safeCode = `
    if (!isNaN(parseFloat(${origin})) && ${divisor} != 0) {
      ${jsCode}
    } else {
      ${destination} = '';
    }`;
    return { displayCode: jsCode, safeCode };
  }
}
